import AhoyTracker from 'shared/ahoy_tracker';
import { IsPremiumUser } from 'shared/vidio_helpers';

export default class PremiumSubscribeModal {
  constructor() {
    this.elements = {
      player       : document.querySelector('.player-data'),
      modal        : document.querySelector('.premium-subscribe-modal'),
      openBtn      : document.querySelector('.js-premium-subscribe-button-open'),
      closeBtn     : document.querySelector('.js-premium-subscribe-button-close'),
      defaulTitle  : document.querySelector('.js-watchpage-premium-banner-title.banner--default'),
      mismatchTitle: document.querySelector('.js-watchpage-premium-banner-title.banner--mismatch')
    };
    this.ahoy = (this.elements.modal) ? new AhoyTracker(this.elements.modal) : false;
  }

  init() {
    this.addOpenHandler();
    this.addCloseHandler();
  }

  addOpenHandler() {
    if(this.elements.openBtn) {
      this.elements.openBtn.addEventListener("click", this.openModal.bind(this));
    }
  }

  addCloseHandler() {
    this.elements.closeBtn.addEventListener("click", this.closeModal.bind(this));
  }

  openModal() {
    this.changePremierTitleWhenInsufficientPackage();
    this.elements.modal.classList.remove("hide");

    setTimeout(function(){
      this.sendGTMImpressionEvent();
      this.sendAhoyImpressionEvent();
    }.bind(this), 10);
  }

  closeModal() {
    setTimeout(function(){
      this.elements.modal.classList.add("hide");
    }.bind(this), 200);
  }

  changePremierTitleWhenInsufficientPackage() {
    if(! IsPremiumUser.get()) {
      return;
    }

    if (this.elements.defaulTitle) {
      this.elements.defaulTitle.classList.add('hide');
    }

    if (this.elements.mismatchTitle) {
      this.elements.mismatchTitle.classList.remove('hide');
    }
  }

  sendGTMImpressionEvent() {
    window.dataLayer.push({
      event: 'impression',
      feature_name: this.elements.modal.getAttribute('data-gtm-name'),
      feature_location: this.elements.modal.getAttribute('data-gtm-loc'),
      feature_type: this.elements.modal.getAttribute('data-gtm-type'),
      feature_index: this.elements.modal.getAttribute('data-gtm-feature-index'),
      category_id: this.elements.modal.getAttribute('data-gtm-category-id'),
      feature_genre: this.elements.modal.getAttribute('data-gtm-feature-genre'),
      blocker_type: this.elements.modal.getAttribute('data-gtm-blocker-type'),
    });
  }

  sendAhoyImpressionEvent() {
    this.ahoy.sendEventImpression();
  }
}
